import { Button } from "@/components/ui/button";
import { AppDrawer, AppTooltip } from "@components";
import { DataGuard } from "@components/DataGuard";
import LayoutHeader from "@components/LayoutHeader";
import { FilterButton, PageSearch, useSearchParamSync } from "@components/PageSearch";
import Panel from "@components/Panel";
import { useAuth } from "@state/auth";
import { useRecordings } from "@state/recordings/state";
import { Plus } from "lucide-solid";
import { For, Show, createSignal } from "solid-js";
import { useService } from "solid-services";
import { css } from "styled-system/css";
import { Flex, Grid } from "styled-system/jsx";
import { scrollbar } from "styled-system/recipes";
import Create from "./Create";
import Filters from "./Filters";
import GroupRow from "./GroupRow";
import SearchResults, { ActiveRecordingFilters } from "./SearchResults";
import { useState } from "./state";

export default function () {
  const { discoveryQuery } = useService(useRecordings)();

  const {
    isCreateFormOpen, setIsCreateFormOpen, editRecording,
    filters, searchInput, setSearchInput, setSearch, activeFilterCount, isFiltering,
  } = useService(useState)()
  const { isAdmin } = useService(useAuth)()
  const [isFilterOpen, setIsFilterOpen] = createSignal(false)

  useSearchParamSync(() => filters().search, setSearch)

  return (
    <Grid gridTemplateRows='auto 1fr' gap='0'>
      <LayoutHeader title='Recordings' rightContent={
        <Flex gap='2' alignItems='center'>
          <PageSearch
            value={searchInput()}
            onInput={setSearchInput}
            placeholder='Search recordings…'
            class={css({ w: { base: '220px', mdDown: '150px', smDown: '130px' } })}
          />
          <AppDrawer
            size='md'
            open={isFilterOpen()}
            onOpenChange={({ open }) => setIsFilterOpen(open)}
            title='Filter Recordings'
            trigger={
              <AppTooltip delay={900} content='Filter Recordings'>
                <FilterButton count={activeFilterCount()} />
              </AppTooltip>
            }
          >
            <Filters onDone={() => setIsFilterOpen(false)} />
          </AppDrawer>
          <Show when={isAdmin()}>
            <AppDrawer
              open={isCreateFormOpen()}
              onOpenChange={({ open }) => setIsCreateFormOpen(open)}
              title={editRecording() ? 'Edit Recording' : 'Add Recording'}
              size='md'
              trigger={
                <Button size='xs' variant='outline'>
                  <Plus />
                  New
                </Button>
              }
            >
              <Create onSuccess={() => setIsCreateFormOpen(false)} />
            </AppDrawer>
          </Show>
        </Flex>
      } />
      <Panel display='grid' gap={6} height={{
        base: 'calc(var(--vh) * 100 - 80px)',
        mdDown: 'calc(var(--vh) * 100 - 110px)'
      }} overflowY='auto' class={scrollbar()} alignContent='start' gridAutoRows={'max-content'}>
        <ActiveRecordingFilters />
        <Show
          when={isFiltering()}
          fallback={
            <DataGuard
              query={discoveryQuery}
            >
              {(groups) => (
                <For each={groups}>
                  {(group) => <GroupRow group={group} />}
                </For>
              )}
            </DataGuard>
          }
        >
          <SearchResults />
        </Show>
      </Panel>
    </Grid>
  )
}
